// @flow

import React from "react";
import { localize } from "redux-i18n";

import { Row, Col, GSGrid, View, Text } from "@components";
import type { Alert, AlertAbsenceReasonScope } from "@modules/service/reducer/alerts/types";
import "./alert-absence-reasons.scss";

type OwnProps = $Exact<{
  data: ?Alert,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;

export class AlertAbsenceReasonsView extends React.Component<Props> {
  get columns() {
    return [
      {
        name: this.props.t("ABSENCE_REASONS"),
        key: "absenceReason",
        align: "left",
        renderCell: ({ row }: { row: AlertAbsenceReasonScope }) => {
          return (
            <View direction="row" justifyContent="space-between" flex={1}>
              <View className={!row.isActive ? "text-color-negative" : ""}>{row.label}</View>
              {!row.isActive && (
                <Text color="negative">{this.props.t("INACTIVE_REASON_LABEL")}</Text>
              )}
            </View>
          );
        },
      },
    ];
  }

  get data() {
    return (this.props.data || {}).absenceReasonScopes;
  }

  render() {
    if (!this.props.data) {
      return <div />;
    }

    return (
      <React.Fragment>
        <div className="w-40 mb-4">
          <hr />
          <h6 className="pb-1 pl-2 text-color-charcoal">
            {this.props.t("ALERT_DETAILS_REASON_SCOPE")}
          </h6>
          <div className="pl-2">
            {!this.data || !this.data.length
              ? this.props.t("ALERT_DETAILS_REASON_SCOPE_ALL")
              : this.props.t("ALERT_DETAILS_REASON_SCOPE_SPECIFIC_REASON")}
          </div>
        </div>
        {this.data ? <GSGrid columns={this.columns} rows={this.data} /> : null}
      </React.Fragment>
    );
  }
}

export default localize()(AlertAbsenceReasonsView);
